export class Slide {
    link: string;
    image: string;
}